function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import { Image } from "@labs/schema";
import clsx from "clsx";
import React, { useRef } from "react";
import { FadeUp } from "../FadeUp";
export default function MobileImages(param) {
    var images = param.images, alt = param.alt;
    var ImageRef = useRef(null);
    return /*#__PURE__*/ React.createElement(FadeUp, {
        yGap: 50
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx("w-full grid gap-8 py-[30px] px-8 my-20 md:mt-24 md:py-[80px] md:px-[120px] xl:py-[110px] lg:px-[130px] mx-auto md:grid-cols-3 justify-center"),
        ref: ImageRef
    }, /*#__PURE__*/ React.createElement(React.Fragment, null, images.map(function(item, index) {
        return /*#__PURE__*/ React.createElement("div", {
            key: index,
            className: "relative w-full drop-shadow-img"
        }, /*#__PURE__*/ React.createElement(Image, _extends({
            className: "lg:max-h-[600px] lg:w-auto lg:mx-auto"
        }, item, {
            alt: alt
        })));
    }))));
}
